<template>
<div class="">
  <div class="banner">
    <img src="https://firebasestorage.googleapis.com/v0/b/foxfox-honda.appspot.com/o/LOGO_VGxLIA-01.png?alt=media&token=ad128f7b-1718-4830-8534-c06999f9e338" style="height:120px !important;">
  </div><br>
  <section>
    <div class="container">
    <h1 class="title">
        BP Close/Unclose Job (สาขา {{ branchSelected }})
    </h1>
    </div>
  </section><br>
  <div class="columns">
    <div class="column is-7 info">
      <h3>Un-Close Job</h3>
      <table class="table" style="width:100%">
        <thead>
          <tr>
            <th><abbr title="runNo">ลำดับที่</abbr></th>
            <th><abbr title="licenseNo">ทะเบียน</abbr></th>
            <th><abbr title="startTime">ชื่อลูกค้า</abbr></th>
            <th><abbr title="startTime">พนักงาน Estimate</abbr></th>
            <th><abbr title="startTime">เหตุผล</abbr></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="car in carList['unclosejob']" v-bind:key="car.id" class="warning">
            <td>{{car.runNo}}</td>
            <td>{{car.licenseNo}}</td>
            <td>{{car.customerName}}</td>
            <td>{{car.staffEstimate}}</td>
            <td width="250"><span style="cursor:pointer" @click="openEdit(car)"><i class="fas fa-edit"></i></span> {{car.unCloseReason}} </td>

          </tr>
        </tbody>
      </table>
    </div>
    <div class="column is-5 info">
      <h3>Close Job This Month</h3>
      <table class="table" style="width:100%">
        <thead>
          <tr>
            <th><abbr title="runNo">ลำดับที่</abbr></th>
            <th><abbr title="runNo">inv No</abbr></th>
            <th><abbr title="licenseNo">ทะเบียน</abbr></th>
            <th><abbr title="startTime">ชื่อลูกค้า</abbr></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="car in carList['closejob']" v-bind:key="car.id" class="success">
            <td>{{car.runNo}}</td>
            <td>{{car.invoiceNo}}</td>
            <td>{{car.licenseNo}}</td>
            <td>{{car.customerName}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div :class="'modal ' + modalActive" >
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">แก้ไขข้อมูล BP</p>
        <button class="delete" aria-label="close" @click="modalActive = ''"></button>
      </header>
      <section class="modal-card-body">
        <div class="field" v-if="dataEdit">
          <label class="label">เหตุผลที่ยังปิดงานไม่ได้</label>
          <div class="control">
            <input class="input" type="text" placeholder="" v-model="dataEdit.unCloseReason"><br>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-success" v-if="!startSave" @click="saveCard">บันทึก</button>
        <button class="button is-success" v-else disabled>กำลังบันทึก...</button>
        <button class="button" @click="modalActive = ''">ยกเลิก</button>
      </footer>
    </div>
  </div>

</div>
</template>

<script>
import draggable from 'vuedraggable'
export default {
  name: 'hello',
  components: {
    draggable
  },
  data: () => ({
    branchCode: '',
    updatedBy: null,
    branch: [],
    unCloseJob: null,
    closeJob: null,
    editable: true,
    isDragging: false,
    delayedDragging: false,
    branchSelected: null,
    carList: {
      'unclosejob': [],
      'closejob': []
    },
    dataAlready: {
      'unclosejob': false,
      'closejob': false
    },
    modalActive: '',
    startSave: false,
    dataEdit: null
  }),
  mounted () {
    if (!this.$session.exists() || (typeof this.$session.get('vgroup') === 'undefined' || this.$session.get('vgroup') === '')) {
      this.$router.push('/?redirectUrl=' + encodeURIComponent(window.location.pathname + window.location.search))
    }
    this.branch = this.$branchList
    const queryString = decodeURIComponent(window.location.search).replace('?liff.state=', '')
    const params = new URLSearchParams(queryString)
    this.branchCode = params.get('branchCode')
    this.branch.map((item) => {
      this.branchSelected = (item.id === this.branchCode) ? item.name : this.branchSelected
      return true
    })
    this.getCarList('unclosejob')
    this.getCarList('closejob')
  },
  methods: {
    add () {
      this.list5.push({'fixed': false, 'name': (Math.floor(Math.random() * 8) + 1) + ' กก ' + (Math.floor(Math.random() * 999) + 1000)})
    },
    getCarList (step) {
      let _this = this
      _this.dataAlready[step] = false
      this.$axios
        .get(`${this.$apiUrl}getCarProgressBP?current=${step}&branch=${_this.branchCode}`)
        .then(response => {
          _this.dataAlready[step] = true
          _this.carList[step] = response.data
        })
    },
    openEdit (car) {
      this.dataEdit = car
      console.log(car)
      this.modalActive = 'is-active'
    },
    async saveCard () {
      this.startSave = true
      let params = {
        carId: this.dataEdit.id,
        runNo: this.dataEdit.runNo,
        expectedDate: this.dataEdit.expectedDate,
        jobType: this.dataEdit.jobType,
        trackDate: this.dataEdit.trackDate,
        unCloseReason: this.dataEdit.unCloseReason
      }
      console.log(params)
      await this.$axios
        .post(`${this.$apiUrl}updateBPInfo`, params)
        .then(response => {
          this.carList['unclosejob'] = this.carList['unclosejob'].map((row) => {
            if (row.id === this.dataEdit.id) {
              row.unCloseReason = this.dataEdit.unCloseReason
            }
            return row
          })
          this.startSave = false
          this.modalActive = ''
          this.dataEdit = null
        })
    },
    orderList () {
      this.list = this.list.sort((one, two) => {
        return one.order - two.order
      })
    },
    onMove ({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element
      const draggedElement = draggedContext.element
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      )
    }
  },
  computed: {
    dragOptions () {
      return {
        animation: 0,
        group: 'description',
        disabled: !this.editable,
        ghostClass: 'ghost'
      }
    },
    listString () {
      return JSON.stringify(this.list, null, 2)
    },
    list2String () {
      return JSON.stringify(this.list2, null, 2)
    }
  },
  watch: {
    isDragging (newValue) {
      if (newValue) {
        this.delayedDragging = true
        return
      }
      this.$nextTick(() => {
        this.delayedDragging = false
      })
    }
  }
}
</script>
<style scoped>
.info table tr td {
  font-size: 13px !important;
}
.banner {
  text-align: center;
  background-color: #000;
}
.warning {
  color: #000;
  background-color: rgb(248, 169, 169);
}
.success {
  background-color: rgb(112, 255, 112);
}
h3 {
  font-size: 18px;
  font-weight: bold;
}
.container {
  margin: 0 auto;
}
.column {
  margin: 3px;
  background-color: #eee;
}
.is-1 {
  width: 11.65%;
}
.item-queue {
  float: left;
  width: 45%;
  margin-left: 10px;
}
.item-wait {
  float: left;
  width: 30%;
  margin-left: 10px;
}
.flip-list-move {
  transition: transform .5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  background: #c8ebfb;
  opacity: .5;
}
.list-group {
  min-height: 350px;
  padding-bottom: 20px;
  background-color: #eee;
}
.list-group-item {
  height: 40px;
  padding: 8px;
  margin-top: 5px;
  background-color: #ccc;
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/BP/closejob.vue